export const TOUR_CREATE_ACTION = "TOUR_CREATE_ACTION";
export const TOUR_LIST_ACTION = "TOUR_LIST_ACTION";
export const TOUR_LIST_SUCCESS = "TOUR_LIST_SUCCESS";
export const TOUR_GET_UPDATE_ACTION = "TOUR_GET_UPDATE_ACTION";
export const TOUR_GET_UPDATE_SUCCESS = "TOUR_GET_UPDATE_SUCCESS";
export const TOUR_DELETE_ACTION = "TOUR_DELETE_ACTION";
export const TOUR_UPDATE_ACTION = "TOUR_UPDATE_ACTION";

export const TOUR_EXPORT_EXCEL_ACTION = 'TOUR_EXPORT_EXCEL_ACTION';
export const TOUR_EXPORT_EXCEL_SUCCESS = 'TOUR_EXPORT_EXCEL_SUCCESS';
export const TOUR_EXPORT_EXCEL_FAIL = 'TOUR_EXPORT_EXCEL_FAIL';
export const TOUR_CLONE_ITEM_ACTION = 'TOUR_CLONE_ITEM_ACTION';
export const TOUR_CLONE_ITEM_SUCCESS = 'TOUR_CLONE_ITEM_SUCCESS';

export const TOUR_LINE_DELETE_ACTION = "TOUR_LINE_DELETE_ACTION";
export const TOUR_LINE_DELETE_SUCCESS = "TOUR_LINE_DELETE_SUCCESS";
export const TOUR_LINE_CREATE_ACTION = "TOUR_LINE_CREATE_ACTION";
export const TOUR_LINE_CREATE_SUCCESS = "TOUR_LINE_CREATE_SUCCESS";
export const TOUR_LINE_UPDATE_ACTION = "TOUR_LINE_UPDATE_ACTION";
export const TOUR_LINE_UPDATE_SUCCESS = "TOUR_LINE_UPDATE_SUCCESS";
export const MULTIPLE_TOUR_LINE_CREATE_ACTION = "MULTIPLE_TOUR_LINE_CREATE_ACTION";
export const MULTIPLE_TOUR_LINE_CREATE_SUCCESS = "MULTIPLE_TOUR_LINE_CREATE_SUCCESS";
export const TOUR_FAIL = "TOUR_FAIL";

export const TOUR_GET_LIST_ACTION = "TOUR_GET_LIST_ACTION";
export const TOUR_GET_LIST_SUCCESS = "TOUR_GET_LIST_SUCCESS";
export const TOUR_GET_LIST_FAIL = "TOUR_GET_LIST_FAIL";
export const TOUR_DETAIL_ACTION = "TOUR_DETAIL_ACTION";
export const TOUR_DETAIL_SUCCESS = "TOUR_DETAIL_SUCCESS";
export const TOUR_DETAIL_FAIL = "TOUR_DETAIL_FAIL";
export const TOUR_DETAIL_UPDATE_ACTION = "TOUR_DETAIL_UPDATE_ACTION";
export const TOUR_DETAIL_CREATE_ACTION = "TOUR_DETAIL_CREATE_ACTION";
export const TOUR_DETAIL_DELETE_ACTION = "TOUR_DETAIL_DELETE_ACTION";

export const TOUR_TYPE_GET_ALL_ACTION = "TOUR_TYPE_GET_ALL_ACTION";
export const TOUR_TYPE_GET_ALL_SUCCESS = "TOUR_TYPE_GET_ALL_SUCCESS";
export const TOUR_TYPE_GET_ALL_FAIL = "TOUR_TYPE_GET_ALL_FAIL";
export const TOUR_TYPE_DETAIL_ACTION = "TOUR_TYPE_DETAIL_ACTION";
export const TOUR_TYPE_DETAIL_SUCCESS = "TOUR_TYPE_DETAIL_SUCCESS";
export const TOUR_TYPE_DETAIL_FAIL = "TOUR_TYPE_DETAIL_FAIL";
export const TOUR_TYPE_DETAIL_UPDATE_ACTION = "TOUR_TYPE_DETAIL_UPDATE_ACTION";
export const TOUR_TYPE_DETAIL_CREATE_ACTION = "TOUR_TYPE_DETAIL_CREATE_ACTION";
export const TOUR_TYPE_DETAIL_DELETE_ACTION = "TOUR_TYPE_DETAIL_DELETE_ACTION";
export const TOUR_TYPE_DETAIL_DELETE_SUCCESS = "TOUR_LINE_DETAIL_DELETE_SUCCESS";


export const TOUR_SURCHARGE_CATEGORIES_GET_ALL_ACTION = "TOUR_SURCHARGE_CATEGORIES_GET_ALL_ACTION";
export const TOUR_SURCHARGE_CATEGORIES_GET_ALL_SUCCESS = "TOUR_SURCHARGE_CATEGORIES_GET_ALL_SUCCESS";
export const TOUR_SURCHARGE_CATEGORIES_GET_ALL_FAIL = "TOUR_SURCHARGE_CATEGORIES_GET_ALL_FAIL";
export const TOUR_SURCHARGE_CATEGORIES_DETAIL_ACTION = "TOUR_SURCHARGE_CATEGORIES_DETAIL_ACTION";
export const TOUR_SURCHARGE_CATEGORIES_DETAIL_SUCCESS = "TOUR_SURCHARGE_CATEGORIES_DETAIL_SUCCESS";
export const TOUR_SURCHARGE_CATEGORIES_DETAIL_FAIL = "TOUR_SURCHARGE_CATEGORIES_DETAIL_FAIL";
export const TOUR_SURCHARGE_CATEGORIES_DETAIL_CREATE_ACTION = "TOUR_SURCHARGE_CATEGORIES_DETAIL_CREATE_ACTION";

export const TOUR_LINE_GET_LIST_ACTION = "TOUR_LINE_GET_LIST_ACTION";
export const TOUR_LINE_GET_LIST_SUCCESS = "TOUR_LINE_GET_LIST_SUCCESS";
export const TOUR_LINE_GET_LIST_FAIL = "TOUR_LINE_GET_LIST_FAIL";
export const TOUR_LINE_DETAIL_ACTION = "TOUR_LINE_DETAIL_ACTION";
export const TOUR_LINE_DETAIL_SUCCESS = "TOUR_LINE_DETAIL_SUCCESS";
export const TOUR_LINE_DETAIL_FAIL = "TOUR_LINE_DETAIL_FAIL";
export const TOUR_LINE_DETAIL_UPDATE_ACTION = "TOUR_LINE_DETAIL_UPDATE_ACTION";
export const TOUR_LINE_DETAIL_CREATE_ACTION = "TOUR_LINE_DETAIL_CREATE_ACTION";
export const TOUR_LINE_DETAIL_DELETE_ACTION = "TOUR_LINE_DETAIL_DELETE_ACTION";
export const TOUR_LINE_DETAIL_DELETE_SUCCESS = "TOUR_LINE_DETAIL_DELETE_SUCCESS";
export const TOUR_LINE_BULK_CREATE_ACTION = "TOUR_LINE_BULK_CREATE_ACTION";
export const TOUR_LINE_BULK_CREATE_SUCCESS = "TOUR_LINE_BULK_CREATE_SUCCESS";
export const TOUR_LINE_BULK_CREATE_FAIL = "TOUR_LINE_BULK_CREATE_FAIL";
export const TOUR_LINE_BULK_UPDATE_ACTION = "TOUR_LINE_BULK_UPDATE_ACTION";
export const TOUR_LINE_BULK_UPDATE_FAIL = "TOUR_LINE_BULK_UPDATE_FAIL";
export const TOUR_LINE_BULK_DELETE_ACTION = "TOUR_LINE_BULK_DELETE_ACTION";
export const TOUR_LINE_BULK_DELETE_FAIL = "TOUR_LINE_BULK_DELETE_FAIL";

export const TOUR_CREATE_TRANSLATE_ACTION = "TOUR_CREATE_TRANSLATE_ACTION";
export const TOUR_CREATE_TRANSLATE_SUCCESS = "TOUR_CREATE_TRANSLATE_SUCCESS";

export const TOUR_UPDATE_TRANSLATE_ACTION = "TOUR_UPDATE_TRANSLATE_ACTION";
export const TOUR_UPDATE_TRANSLATE_SUCCESS = "TOUR_UPDATE_TRANSLATE_SUCCESS";

export const TOUR_DELETE_TRANSLATE_ACTION = "TOUR_DELETE_TRANSLATE_ACTION";
export const TOUR_DELETE_TRANSLATE_SUCCESS = "TOUR_DELETE_TRANSLATE_SUCCESS";



/* TOURLINE TICKET */

export const TOUR_ITEM_TICKET_GET_ACTION = "TOUR_ITEM_TICKET_GET_ACTION";
export const TOUR_ITEM_TICKET_GET_SUCCESS = "TOUR_ITEM_TICKET_GET_SUCCESS"

export const TOUR_ITEM_TICKET_DETAIL_ACTION = "TOUR_ITEM_TICKET_DETAIL_ACTION";
export const TOUR_ITEM_TICKET_DETAIL_SUCCESS = "TOUR_ITEM_TICKET_DETAIL_SUCCESS";
export const TOUR_ITEM_TICKET_DETAIL_FAIL = "TOUR_ITEM_TICKET_DETAIL_FAIL";

export const TOUR_ITEM_TICKET_DETAIL_UPDATE_ACTION = "TOUR_ITEM_TICKET_DETAIL_UPDATE_ACTION";
export const TOUR_ITEM_TICKET_DETAIL_CREATE_ACTION = "TOUR_ITEM_TICKET_DETAIL_CREATE_ACTION";
export const TOUR_ITEM_TICKET_DETAIL_DELETE_ACTION = "TOUR_ITEM_TICKET_DETAIL_DELETE_ACTION";

export const TOUR_ITEM_MODAL_BULK_ACTION = "TOUR_ITEM_MODAL_BULK_ACTION";

export const TOUR_LIST_ALL_ACTION = "TOUR_LIST_ALL_ACTION";
export const TOUR_LIST_ALL_SUCCESS = "TOUR_LIST_ALL_SUCCESS";

export const TOUR_LINE_TICKET_GET_ACTION = "TOUR_LINE_TICKET_GET_ACTION";
export const TOUR_LINE_TICKET_GET_SUCCESS = "TOUR_LINE_TICKET_GET_SUCCESS";

export const DETAIL_TOUR_TICKET_GET_ACTION = "tourDetail/TOUR_TICKET_GET_ACTION";
export const DETAIL_TOUR_TICKET_GET_SUCCESS = "tourDetail/TOUR_TICKET_GET_SUCCESS";

export const DETAIL_TOUR_TICKET_DETAIL_ACTION = "tourDetail/TOUR_TICKET_DETAIL_ACTION";
export const DETAIL_TOUR_TICKET_DETAIL_SUCCESS = "tourDetail/TOUR_TICKET_DETAIL_SUCCESS";
export const DETAIL_TOUR_TICKET_DETAIL_FAIL = "tourDetail/TOUR_TICKET_DETAIL_FAIL";

export const DETAIL_TOUR_TICKET_DETAIL_UPDATE_ACTION = "tourDetail/TOUR_TICKET_DETAIL_UPDATE_ACTION";
export const DETAIL_TOUR_TICKET_DETAIL_CREATE_ACTION = "tourDetail/TOUR_TICKET_DETAIL_CREATE_ACTION";
export const DETAIL_TOUR_TICKET_DETAIL_DELETE_ACTION = "tourDetail/TOUR_TICKET_DETAIL_DELETE_ACTION";

export const DETAIL_TOUR_TICKET_CREATE_TRANSLATE_ACTION = "tourDetail/TOUR_TICKET_CREATE_TRANSLATE_ACTION";
export const DETAIL_TOUR_TICKET_CREATE_TRANSLATE_SUCCESS = "tourDetail/TOUR_TICKET_CREATE_TRANSLATE_SUCCESS";

export const DETAIL_TOUR_TICKET_UPDATE_TRANSLATE_ACTION = "tourDetail/TOUR_TICKET_UPDATE_TRANSLATE_ACTION";
export const DETAIL_TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS = "tourDetail/TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS";

export const DETAIL_TOUR_TICKET_DELETE_TRANSLATE_ACTION = "tourDetail/TOUR_TICKET_DELETE_TRANSLATE_ACTION";
export const DETAIL_TOUR_TICKET_DELETE_TRANSLATE_SUCCESS = "tourDetail/TOUR_TICKET_DELETE_TRANSLATE_SUCCESS";

export const DETAIL_TOUR_TICKET_FAIL = "tourDetail/DETAIL_TOUR_TICKET_FAIL";


export const TAGSKUVW_GET_ALL_ACTION = "TAGSKUVW_GET_ALL_ACTION";
export const TAGSKUVW_GET_ALL_SUCCESS = "TAGSKUVW_GET_ALL_SUCCESS";
export const TAGSKUVW_GET_ALL_FAIL = "TAGSKUVW_GET_ALL_FAIL";
export const TAGSKUVW_DETAIL_ACTION = "TAGSKUVW_DETAIL_ACTION";
export const TAGSKUVW_DETAIL_SUCCESS = "TAGSKUVW_DETAIL_SUCCESS";
export const TAGSKUVW_DETAIL_FAIL = "TAGSKUVW_DETAIL_FAIL";
export const TAGSKUVW_DETAIL_UPDATE_ACTION = "TAGSKUVW_DETAIL_UPDATE_ACTION";
export const TAGSKUVW_DETAIL_CREATE_ACTION = "TAGSKUVW_DETAIL_CREATE_ACTION";
export const TAGSKUVW_DETAIL_DELETE_ACTION = "TAGSKUVW_DETAIL_DELETE_ACTION";
export const TAGSKUVW_DETAIL_DELETE_SUCCESS = "TAGSKUVW_DETAIL_DELETE_SUCCESS";
